// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.modal-search {
  display: flex;
  gap: 30px;
}
.modal-search__field {
  display: flex;
  flex-direction: column;
}
.modal-search__field span {
  color: #1D283C;
  font-size: 16px;
  font-weight: 500;
}
.modal-search .w-85 {
  width: 85%;
}
.modal-search .w-50 {
  width: 50%;
}
.modal-search__input {
  outline: none;
  border: none;
  border-bottom: 2px solid #d9d9d9;
  height: 28px;
  margin-bottom: 20px;
}
.modal-search__search {
  width: 10%;
  margin: auto;
  cursor: pointer;
  color: #a6a6a6;
}
.modal-search__search :hover {
  background-color: #d9d9d9;
}

.modal-delete {
  display: flex;
  flex-direction: column;
}
.modal-delete__top {
  display: flex;
  text-align: center;
  padding-top: 20px;
}
.modal-delete .w-50 {
  width: 50%;
}
.modal-delete p {
  color: #a6a6a6;
  font-size: 14px;
  font-weight: 500;
}

.search-modal .ant-modal-content {
  border-radius: 10px;
  padding: 30px;
  background: var(--color-surface-overlay);
}
.search-modal .search-container {
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 20px;
  background: transparent;
  border-radius: 8px;
  width: 665px;
  margin: 0 auto;
  min-height: 300px;
}
.search-modal .search-row {
  display: flex;
  gap: 40px;
  margin-bottom: 0;
}
.search-modal .search-row .search-field {
  flex: 0 0 300px;
  width: 300px;
}
.search-modal .search-field {
  flex: 1 1;
}
.search-modal .search-field label {
  display: block;
  margin-bottom: 8px;
  color: var(--color-text);
  font-weight: 600;
  font-size: 16px;
  text-align: left;
}
.search-modal .search-field input, .search-modal .search-field .ant-picker {
  width: 100%;
  height: 40px;
  box-sizing: border-box;
  padding: 8px 12px;
  border: 1px solid var(--color-field-border);
  border-radius: 6px;
  font-size: 14px;
  background: var(--color-field-bg);
  color: var(--color-text);
}
.search-modal .search-field input:focus, .search-modal .search-field .ant-picker:focus {
  border-color: #2DACEC;
  box-shadow: 0 0 0 2px rgba(45, 172, 236, 0.1);
  outline: none;
}
.search-modal .search-field input::placeholder, .search-modal .search-field .ant-picker::placeholder {
  color: #b5b5c3;
}
.search-modal .search-field .ant-picker .ant-picker-input input {
  border: none;
  height: auto;
}
.search-modal .search-field .ant-picker .ant-picker-input .ant-picker-range-separator .ant-picker-separator {
  border: none;
}
.search-modal .search-field .ant-picker.ant-picker-focused {
  border-color: #2DACEC;
  box-shadow: 0 0 0 2px rgba(45, 172, 236, 0.1);
}
.search-modal .search-field .ant-picker .ant-picker-suffix,
.search-modal .search-field .ant-picker .ant-picker-clear {
  color: #b5b5c3;
  cursor: pointer !important;
  padding: 0 8px;
}
.search-modal .search-field .ant-picker .ant-picker-suffix:hover,
.search-modal .search-field .ant-picker .ant-picker-clear:hover {
  color: #2DACEC;
}
.search-modal .search-field .ant-picker .ant-picker-suffix .anticon,
.search-modal .search-field .ant-picker .ant-picker-suffix span,
.search-modal .search-field .ant-picker .ant-picker-clear .anticon,
.search-modal .search-field .ant-picker .ant-picker-clear span {
  font-size: 16px;
  cursor: pointer !important;
  pointer-events: auto !important;
}
.search-modal .search-field .ant-picker .ant-picker-suffix *,
.search-modal .search-field .ant-picker .ant-picker-clear * {
  cursor: pointer !important;
  pointer-events: auto !important;
}
.search-modal .search-row:last-child {
  display: flex;
  align-items: flex-end;
  gap: 24px;
}
.search-modal .search-row:last-child .search-field {
  flex: 0 0 300px;
  width: 300px;
}
.search-modal .search-button {
  background: #2DACEC;
  color: white;
  border: none;
  height: 48px;
  padding: 0 119px;
  border-radius: 6px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-left: auto;
  margin-top: 10px;
  font-size: 20px;
  font-weight: 500;
  transition: all 0.2s ease;
}
.search-modal .search-button:hover {
  background: #16a3ea;
}
.search-modal .search-button .anticon {
  font-size: 16px;
}

.custom-modal-confirm .ant-modal-content {
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}
.custom-modal-confirm .ant-modal-body {
  padding: 24px;
}
.custom-modal-confirm .ant-modal-confirm-content {
  margin-top: 16px;
  margin-bottom: 24px;
}
.custom-modal-confirm .modal-message p {
  margin-bottom: 12px;
  line-height: 1;
  font-size: 14px;
  color: var(--color-text-muted);
}
.custom-modal-confirm .modal-message p:last-child {
  margin-bottom: 0;
}
.custom-modal-confirm .ant-modal-confirm-btns {
  margin-top: 24px;
}

/* 버튼 호버 효과를 위한 스타일 */
.action-button-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all 0.2s ease;
}

.action-button {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 8px;
  border-radius: 8px;
  transition: all 0.2s ease;
}
.action-button:hover {
  background-color: rgba(0, 0, 0, 0.05);
  transform: translateY(-2px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}
.action-button:hover img {
  transform: scale(1.05);
}
.action-button:hover p {
  color: #007bff !important;
}
.action-button img {
  transition: transform 0.2s ease;
}
.action-button p {
  margin-top: 5px;
  transition: color 0.2s ease;
}`, "",{"version":3,"sources":["webpack://./src/pages/History/component/Modal/Modal.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAGhB;EACE,aAAA;EACA,SAAA;AADF;AAEE;EACE,aAAA;EACA,sBAAA;AAAJ;AACI;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AACN;AAEE;EACE,UAAA;AAAJ;AAEE;EACE,UAAA;AAAJ;AAEE;EACE,aAAA;EACA,YAAA;EACA,gCAAA;EACA,YAAA;EACA,mBAAA;AAAJ;AAEE;EACE,UAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;AAAJ;AACI;EACE,yBAAA;AACN;;AAIA;EACE,aAAA;EACA,sBAAA;AADF;AAEE;EACE,aAAA;EACA,kBAAA;EACA,iBAAA;AAAJ;AAEE;EACE,UAAA;AAAJ;AAEE;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AAAJ;;AAKE;EACE,mBAAA;EACA,aAAA;EAGA,wCAAA;AAJJ;AAOE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;EACA,kBAAA;EAEA,YAAA;EACA,cAAA;EACA,iBAAA;AANJ;AASE;EACE,aAAA;EACA,SAAA;EACA,gBAAA;AAPJ;AASI;EACE,eAAA;EACA,YAAA;AAPN;AAWE;EACE,SAAA;AATJ;AAWI;EACE,cAAA;EACA,kBAAA;EACA,wBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;AATN;AAeI;EACE,WAAA;EACA,YAAA;EACA,sBAAA;EACA,iBAAA;EACA,2CAAA;EACA,kBAAA;EACA,eAAA;EACA,iCAAA;EACA,wBAAA;AAbN;AAgBM;EACE,qBAAA;EACA,6CAAA;EACA,aAAA;AAdR;AAkBM;EACE,cAAA;AAhBR;AAyBQ;EACE,YAAA;EACA,YAAA;AAvBV;AA4BU;EACE,YAAA;AA1BZ;AA+BM;EACE,qBAAA;EACA,6CAAA;AA7BR;AAiCM;;EAEE,cAAA;EACA,0BAAA;EACA,cAAA;AA/BR;AAiCQ;;EACE,cAAA;AA9BV;AAkCQ;;;;EAEE,eAAA;EACA,0BAAA;EACA,+BAAA;AA9BV;AAmCM;;EAEE,0BAAA;EACA,+BAAA;AAjCR;AAuCE;EACE,aAAA;EACA,qBAAA;EACA,SAAA;AArCJ;AAuCI;EACE,eAAA;EACA,YAAA;AArCN;AAmDE;EACE,mBAAA;EACA,YAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;AAjDJ;AAmDI;EACE,mBAAA;AAjDN;AAqDI;EACE,eAAA;AAnDN;;AAyDE;EACE,kBAAA;EACA,0CAAA;AAtDJ;AAyDE;EACE,aAAA;AAvDJ;AA0DE;EACE,gBAAA;EACA,mBAAA;AAxDJ;AA4DI;EACE,mBAAA;EACA,cAAA;EACA,eAAA;EACA,8BAAA;AA1DN;AA6DI;EACE,gBAAA;AA3DN;AA+DE;EACE,gBAAA;AA7DJ;;AAiEA,qBAAA;AACA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,yBAAA;AA9DF;;AAiEA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;AA9DF;AAgEE;EACE,qCAAA;EACA,2BAAA;EACA,wCAAA;AA9DJ;AAgEI;EACE,sBAAA;AA9DN;AAiEI;EACE,yBAAA;AA/DN;AAmEE;EACE,+BAAA;AAjEJ;AAoEE;EACE,eAAA;EACA,2BAAA;AAlEJ","sourcesContent":["// NOTE: 이 블록(.modal-search)은 현재 어느 JSX 에서도 렌더되지 않는 죽은 규칙입니다.\n// 실제로 쓰이는 검색 모달은 아래 .search-modal 입니다. 다크모드 대응에서 제외한\n// 이유가 그것이며, 정리는 별도 커밋으로 미룹니다.\n.modal-search {\n  display: flex;\n  gap: 30px;\n  &__field {\n    display: flex;\n    flex-direction: column;\n    span {\n      color: #1D283C;\n      font-size: 16px;\n      font-weight: 500;\n    }\n  }\n  .w-85 {\n    width: 85%;\n  }\n  .w-50 {\n    width: 50%;\n  }\n  &__input {\n    outline: none;\n    border: none;\n    border-bottom: 2px solid #d9d9d9;\n    height: 28px;\n    margin-bottom: 20px;\n  }\n  &__search {\n    width: 10%;\n    margin: auto;\n    cursor: pointer;\n    color: #a6a6a6;\n    :hover {\n      background-color: #d9d9d9;\n    }\n  }\n}\n\n.modal-delete {\n  display: flex;\n  flex-direction: column;\n  &__top {\n    display: flex;\n    text-align: center;\n    padding-top: 20px;\n  }\n  .w-50 {\n    width: 50%;\n  }\n  p {\n    color: #a6a6a6;\n    font-size: 14px;\n    font-weight: 500;\n  }\n}\n\n.search-modal {\n  .ant-modal-content {\n    border-radius: 10px;\n    padding: 30px;\n    // 흰색을 박아두면 다크모드에서 이 모달만 밝게 남습니다. 라이트에서는\n    // --color-surface-overlay 가 그대로 #FFFFFF 라 기존과 동일합니다.\n    background: var(--color-surface-overlay);\n  }\n\n  .search-container {\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n    padding: 20px;\n    background: transparent;\n    border-radius: 8px;\n    // box-shadow: 0 2px 8px rgba(0,0,0,0.05);\n    width: 665px;\n    margin: 0 auto;\n    min-height: 300px;\n  }\n\n  .search-row {\n    display: flex;\n    gap: 40px;\n    margin-bottom: 0;\n\n    .search-field {\n      flex: 0 0 300px;\n      width: 300px;\n    }\n  }\n\n  .search-field {\n    flex: 1;\n    \n    label {\n      display: block;\n      margin-bottom: 8px;\n      color: var(--color-text);\n      font-weight: 600;\n      font-size: 16px;\n      text-align: left;\n    }\n\n    // 모든 인풋 + RangePicker 크기 통일 (가로 100% / 세로 40px). 이전엔\n    // 텍스트 인풋 30px, RangePicker 48px·326px로 중구난방이었음.\n    // 색은 필드 토큰으로 넘겨 다크모드에서 회색 표면으로 함께 전환되게 합니다.\n    input, .ant-picker {\n      width: 100%;\n      height: 40px;\n      box-sizing: border-box;\n      padding: 8px 12px;\n      border: 1px solid var(--color-field-border);\n      border-radius: 6px;\n      font-size: 14px;\n      background: var(--color-field-bg);\n      color: var(--color-text);\n\n      // 포커스 색은 두 모드 모두에서 잘 보이므로 기존 값을 유지합니다.\n      &:focus {\n        border-color: #2DACEC;\n        box-shadow: 0 0 0 2px rgba(45, 172, 236, 0.1);\n        outline: none;\n      }\n\n      // #b5b5c3 는 어두운 필드 위에서도 충분히 읽히므로 기존 값을 유지합니다.\n      &::placeholder {\n        color: #b5b5c3;\n      }\n    }\n\n    // RangePicker 전용 — 높이/폭은 위 공통 규칙(40px / 100%)을 그대로 쓰고\n    // 내부 input 보더와 separator 정리만 유지.\n    .ant-picker {\n      // RangePicker 내부의 input 스타일\n      .ant-picker-input {\n        input {\n          border: none;  // input 테두리 제거\n          height: auto;  // 부모(40px)에 맡김 — 중복 height 제거\n        }\n\n        // 구분선 스타일 유지\n        .ant-picker-range-separator {\n          .ant-picker-separator {\n            border: none;\n          }\n        }\n      }\n\n      &.ant-picker-focused {\n        border-color: #2DACEC;  // focus 시 테두리 색상 변경\n        box-shadow: 0 0 0 2px rgba(45, 172, 236, 0.1);  // focus 시 그림자 효과\n      }\n\n      // 달력 아이콘과 클리어 버튼 스타일\n      .ant-picker-suffix,\n      .ant-picker-clear {\n        color: #b5b5c3;\n        cursor: pointer !important;  // 강제로 포인터 적용\n        padding: 0 8px;\n\n        &:hover {\n          color: #2DACEC;\n        }\n\n        // 아이콘 자체에도 포인터 적용\n        .anticon,\n        span {\n          font-size: 16px;\n          cursor: pointer !important;\n          pointer-events: auto !important;\n        }\n      }\n\n      // 클릭 가능한 영역 전체에 포인터 적용\n      .ant-picker-suffix *,\n      .ant-picker-clear * {\n        cursor: pointer !important;\n        pointer-events: auto !important;\n      }\n    }\n  }\n\n  // 마지막 row 스타일 수정\n  .search-row:last-child {\n    display: flex;\n    align-items: flex-end;\n    gap: 24px;\n\n    .search-field {\n      flex: 0 0 300px;\n      width: 300px;\n    }\n  }\n\n  // Report Name 필드 스타일 제거 (이미 동일한 스타일 적용됨)\n  .search-row:first-child {\n    .search-field:first-child {\n      // 기존 스타일 제거\n    }\n    .search-field:last-child {\n      // 기존 스타일 제거\n    }\n  }\n\n  .search-button {\n    background: #2DACEC;\n    color: white;\n    border: none;\n    height: 48px;\n    padding: 0 119px;\n    border-radius: 6px;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n    margin-left: auto;\n    margin-top: 10px;\n    font-size: 20px;\n    font-weight: 500;\n    transition: all 0.2s ease;\n    \n    &:hover {\n      background: darken(#2DACEC, 5%);\n      // transform: translateY(-1px);\n    }\n\n    .anticon {\n      font-size: 16px;\n    }\n  }\n}\n\n.custom-modal-confirm {\n  .ant-modal-content {\n    border-radius: 8px;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  }\n  \n  .ant-modal-body {\n    padding: 24px;\n  }\n  \n  .ant-modal-confirm-content {\n    margin-top: 16px;\n    margin-bottom: 24px;\n  }\n  \n  .modal-message {\n    p {\n      margin-bottom: 12px;\n      line-height: 1;\n      font-size: 14px;\n      color: var(--color-text-muted);\n    }\n    \n    p:last-child {\n      margin-bottom: 0;\n    }\n  }\n  \n  .ant-modal-confirm-btns {\n    margin-top: 24px;\n  }\n}\n\n/* 버튼 호버 효과를 위한 스타일 */\n.action-button-wrapper {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  transition: all 0.2s ease;\n}\n\n.action-button {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 8px;\n  border-radius: 8px;\n  transition: all 0.2s ease;\n  \n  &:hover {\n    background-color: rgba(0, 0, 0, 0.05);\n    transform: translateY(-2px);\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n    \n    img {\n      transform: scale(1.05);\n    }\n    \n    p {\n      color: #007bff !important;\n    }\n  }\n  \n  img {\n    transition: transform 0.2s ease;\n  }\n  \n  p {\n    margin-top: 5px;\n    transition: color 0.2s ease;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
